import { useWeb3StateContext } from "contexts/global/web3StateContext";
import React from "react";

export const useIsUserLoggedIn = () => {
  // console.log("useIsUserLoggedIn");

  const { userAddress } = useWeb3StateContext();
  return Boolean(userAddress !== null);
};
